import React, { createContext, useContext, useState, useEffect } from "react";
import { authAPI } from "../api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const storedUser = localStorage.getItem("@user_data");
        const token = localStorage.getItem("@auth_token");
        if (storedUser && token) {
            setUser(JSON.parse(storedUser));
        }
        setLoading(false);
    }, []);

    const signIn = async (phone, password) => {
        try {
            const res = await authAPI.login(phone, password);
            const { token, user } = res.data;
            localStorage.setItem("@auth_token", token);
            localStorage.setItem("@user_data", JSON.stringify(user));
            localStorage.setItem("@user_id", user.uid_master || user.id);
            setUser(user);
            return { success: true };
        } catch (err) {
            return { success: false, error: err.response?.data?.message || "Ошибка входа" };
        }
    };

    const signOut = async () => {
        try {
            await authAPI.logout();
        } catch (e) {}
        localStorage.removeItem("@auth_token");
        localStorage.removeItem("@user_data");
        localStorage.removeItem("@user_id");
        setUser(null);
    };

    return <AuthContext.Provider value={{ user, loading, signIn, signOut }}>{children}</AuthContext.Provider>;
};

export const useAuth = () => useContext(AuthContext);
